mutation submitOnboarding($companyId: ID!) {
  state: submitOnboarding(companyId: $companyId) {
    companyId
    state
  }
}
